import React from "react";
import { Skeleton } from "@common/skeleton";
import styles from "./styles.scss";

function Discussion() {
  return <Skeleton className={styles.discussion} />;
}

export { Discussion };
